//@ts-ignore
window.global ||= window;
